import { ComparatorStep } from '@kizi/comparator-core';

import getUserInput from './getUserInput';
import startWidget from './startWidget';
import overview from './overview';
import apply from './apply';
import checkout from './checkout';
import comparison from './comparison';
import summary from './summary';

export const steps: ComparatorStep[] = [
  startWidget,
  getUserInput,
  overview,
  comparison,
  summary,
  apply,
  checkout,
];

export default steps;
